import type { AccordionProps } from 'features/ContactSidebar/Accordion/Accordion.types';
import { Disclosure, Transition } from '@headlessui/react';
import { PropsWithChildren } from 'react';
import { ArrowDownIcon } from 'icons/outline';
import clsx from 'clsx';

export const Accordion = (props: PropsWithChildren<AccordionProps>) => {
  const { title, children } = props;
  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex items-center justify-between w-full px-2 py-1 text-sm font-bold text-left text-gray-900 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-primary-poppy-red focus-visible:ring-opacity-75">
            {title}
            <ArrowDownIcon
              className={clsx('w-3.5 h-3.5 text-primary-pure-blue', {
                'transform rotate-180': open,
              })}
            />
          </Disclosure.Button>

          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel className="px-2 py-1 text-sm">{children}</Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
};

Accordion.displayName = 'Accordion';
